import boniAccommodationPhoto from '../assets/listings/boni-deluxe-pool-bungalow-bedroom-pool-view.webp'

// Owner-supplied photo selected for local review without changing the CMS document.
const boniAccommodationImage = {
  src: boniAccommodationPhoto,
  alt: 'A Deluxe Pool Bungalow bedroom at Boni Beach Lombok, with teak furniture, a thatched ceiling and its private pool visible through glass doors.',
}

export function listingImageOverride(listing) {
  return listing?._id === 'listing-boni-beach-lombok' ? boniAccommodationImage : null
}
